/*
 *
 * StoriesPage reducer
 *
 */

import produce from 'immer';
import { ActionTypes } from './actions';

export const key = 'storiesPage';
export const initialState = {
    page: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        loadableIds: [],
        loadedIds: [],
        res: [],
    },
};

/* eslint-disable no-param-reassign, default-case */
function storiesPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case ActionTypes.RESET_PAGE:
                draft.page.res = initialState.page.res;
                return draft;
            case ActionTypes.FETCH_PAGE_STARTED:
                draft.page.isLoading = true;
                draft.page.isError = false;
                draft.page.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PAGE_SUCCESSFULLY:
                draft.page.isLoading = false;
                draft.page.isLoaded = true;
                draft.page.res = action.res;
                return draft;
            case ActionTypes.FETCH_PAGE_FAILED:
                draft.page.isLoading = false;
                draft.page.isError = true;
                draft.page.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PAGE_CANCELLED:
                draft.page.isLoading = false;
                return draft;
            case ActionTypes.SET_PAGE_IS_LOADED:
                draft.page.isLoaded = action.isLoaded;
                return draft;
            case ActionTypes.SET_PAGE_LOADABLE_IDS:
                draft.page.loadableIds = action.loadableIds;
                return draft;
            case ActionTypes.SET_PAGE_LOADED_IDS:
                draft.page.loadedIds = action.loadedIds;
                return draft;
            default:
                return draft;
        }
    });
}

export default storiesPageReducer;
